import { Navigate, Route, Routes } from 'react-router-dom';
import AppShell from './components/AppShell';
import ProtectedRoute from './components/ProtectedRoute';
import ActivationCodesPage from './pages/ActivationCodesPage';
import AccessLogPage from './pages/AccessLogPage';
import AdoptionPage from './pages/AdoptionPage';
import BookPage from './pages/BookPage';
import ContentManagerPage from './pages/ContentManagerPage';
import DashboardPage from './pages/DashboardPage';
import DevicesPage from './pages/DevicesPage';
import MyLibraryPage from './pages/MyLibraryPage';
import InternalUsersPage from './pages/InternalUsersPage';
import MastersPage from './pages/MastersPage';
import RegisteredUsersPage from './pages/RegisteredUsersPage';
import ProfilePage from './pages/ProfilePage';
import RenewalsPage from './pages/RenewalsPage';
import ReportsPage from './pages/ReportsPage';
import RepositoryPage from './pages/RepositoryPage';
import SchoolDetailPage from './pages/SchoolDetailPage';
import TeacherReviewPage from './pages/TeacherReviewPage';
import VerificationQueuePage from './pages/VerificationQueuePage';
import SchoolsPage from './pages/SchoolsPage';
import LoginPage from './pages/auth/LoginPage';
import ResetPasswordPage from './pages/auth/ResetPasswordPage';
import StudentRegisterPage from './pages/auth/StudentRegisterPage';
import TeacherRegisterPage from './pages/auth/TeacherRegisterPage';
import { ADMINISTRATION, STAFF } from './roles';

/** Routes for every navigation entry. */
export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register/teacher" element={<TeacherRegisterPage />} />
      <Route path="/register/student" element={<StudentRegisterPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />

      <Route
        element={
          <ProtectedRoute>
            <AppShell />
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<DashboardPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/devices" element={<DevicesPage />} />
        <Route
          path="/users"
          element={
            <ProtectedRoute roles={ADMINISTRATION}>
              <InternalUsersPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/registered"
          element={
            <ProtectedRoute roles={ADMINISTRATION}>
              <RegisteredUsersPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/masters"
          element={
            <ProtectedRoute roles={ADMINISTRATION}>
              <MastersPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/verification"
          element={
            <ProtectedRoute roles={STAFF}>
              <VerificationQueuePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/verification/:teacherUserId"
          element={
            <ProtectedRoute roles={STAFF}>
              <TeacherReviewPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/schools"
          element={
            <ProtectedRoute roles={STAFF}>
              <SchoolsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/schools/:schoolId"
          element={
            <ProtectedRoute roles={STAFF}>
              <SchoolDetailPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/adoption"
          element={
            <ProtectedRoute roles={STAFF}>
              <AdoptionPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/codes"
          element={
            <ProtectedRoute roles={[...STAFF, 'TEACHER']}>
              <ActivationCodesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/library"
          element={
            <ProtectedRoute roles={['STUDENT']}>
              <MyLibraryPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/library/:titleId"
          element={
            <ProtectedRoute roles={['STUDENT']}>
              <BookPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/content"
          element={
            <ProtectedRoute roles={ADMINISTRATION}>
              <ContentManagerPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/repository"
          element={
            <ProtectedRoute roles={['TEACHER']}>
              <RepositoryPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/security"
          element={
            <ProtectedRoute roles={ADMINISTRATION}>
              <AccessLogPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/renewals"
          element={
            <ProtectedRoute roles={STAFF}>
              <RenewalsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/reports"
          element={
            <ProtectedRoute roles={STAFF}>
              <ReportsPage />
            </ProtectedRoute>
          }
        />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
